import ArgonBox from "components/ArgonBox";
import React from "react";
import { useState } from "react";
import PropTypes from "prop-types";
import { useEffect } from "react";
import ArgonTypography from "components/ArgonTypography";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import breakpoints from "assets/theme/base/breakpoints";
import { TabScrollButton } from "@mui/material";
import { height, width } from "@mui/system";

function ApnaTabs({ tabsData, onTabChange, activeTab }) {
  const [tabValue, setTabValue] = useState(0);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");

  // Sync tabValue with activeTab prop
  useEffect(() => {
    if (activeTab) {
      const index = tabsData.findIndex((tab) => (tab.status || tab.label) === activeTab);
      if (index !== -1) {
        setTabValue(index);
      } else {
        // If activeTab is not in this tab group, reset to no selection
        setTabValue(-1);
      }
    }
  }, [activeTab, tabsData, tabValue]);

  useEffect(() => {
    function handleTabsOrientation() {
      setTabsOrientation(window.innerWidth < breakpoints.sm ? "vertical" : "horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, []);

  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
    if (onTabChange && tabsData[newValue]) {
      // Pass status if available, otherwise pass label
      const valueToPass = tabsData[newValue].status || tabsData[newValue].label;
      onTabChange(valueToPass);
    }
  };

  return (
    <ArgonBox sx={{ bgcolor: "background.paper", height: "auto", width: "100%" }}>
      <ArgonBox>
        <Tabs
          orientation="horizontal"
          value={tabValue >= 0 ? tabValue : false}
          onChange={handleSetTabValue}
          variant="standard"
          TabIndicatorProps={{ style: { display: "none" } }} // ✅ ink bar remove
          //  variant="scrollable"
          //  scrollButtons="auto"
          //  allowScrollButtonsMobile
          sx={{
            "& .MuiTabs-flexContainer": {
              flexWrap: "wrap",
              justifyContent: "flex-start !important",
              gap: "8px",
            },
            "& .MuiTab-root": {
              minHeight: "32px", // ✅ default height chhoti
              padding: "4px 10px", // ✅ default padding chhoti
              borderRadius: "8px",
              textTransform: "none",
              transition: "all 0.2s ease",
              flex: "unset", // ✅ prevent stretch
            },
            "& .Mui-selected": {
              padding: "2px 16px", // ✅ selected tab pe zyada px
              backgroundColor: "#FFFFFF",
              color: "white !important",
            },
          }}
        >
          {tabsData.map((tab, index) => {
            return (
              <Tab
                key={index}
                sx={{ minHeight: "auto" }}
                label={
                  <ArgonBox display="flex" alignItems="center" justifyContent="center" gap={"10px"}>
                    <ArgonTypography
                      variant="button"
                      textTransform="none"
                      fontWeight="medium"
                      color="text"
                    >
                      {tab.label}
                    </ArgonTypography>

                    {/* Either count OR icon */}
                    {(tab.count !== undefined || tab.icon) && (
                      <ArgonTypography
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        variant="caption"
                        fontWeight="medium"
                        sx={{
                          px: "11px",
                          py: "11px",
                          backgroundColor: tab.icon
                            ? tab.status === "success"
                              ? "#1a6808b7" // ✅ green for success
                              : "#e71212b7" // ✅ red for error
                            : "#3396D3", // ✅ fixed color for count
                          color: "white !important",
                          borderRadius: "50%",
                          width: "17px",
                          height: "17px",
                          textAlign: "center",
                        }}
                      >
                        {tab.count !== undefined ? tab.count : <ArgonBox>{tab.icon}</ArgonBox>}
                      </ArgonTypography>
                    )}
                  </ArgonBox>
                }
              />
            );
          })}
        </Tabs>
      </ArgonBox>
      {/* 👇 Render the selected tab content */}
      <ArgonBox mt={2}>{tabsData[tabValue] && tabsData[tabValue].content}</ArgonBox>
    </ArgonBox>
  );
}
ApnaTabs.propTypes = {
  tabsData: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // ✅ optional
      icon: PropTypes.node, // ✅ optional
      status: PropTypes.string, // ✅ for icon bg
      content: PropTypes.node,
    })
  ).isRequired,
  onTabChange: PropTypes.func,
  activeTab: PropTypes.string, // Optional: external control of active tab
};

export default ApnaTabs;

//                  sx={{
// "& .MuiTabs-scroller": {
//   display: "flex",
//   justifyContent: "center", // pura block center me
//   overflowX: tabsOrientation === "horizontal" ? "auto !important" : "hidden",
//   overflowY: tabsOrientation === "vertical" ? "auto !important" : "hidden",

//   // Scrollbar hide
//   scrollbarWidth: "none",
//   msOverflowStyle: "none",
//   "&::-webkit-scrollbar": { display: "none" },
// },

// "& .MuiTabs-flexContainer": {
//   display: "inline-flex",
//   justifyContent: "flex-start",
//   alignItems: "center",
//   flexWrap: "nowrap",
//   gap: "12px",
//   // ✅ padding only jab scrollable ho
//   padding: tabsData.length > 4
//     ? (tabsOrientation === "horizontal" ? "0 16px" : "16px 0")
//     : 0,
// },

// "& .MuiTab-root": {
//   flexShrink: 0,
//   minHeight: "auto",
//    // ✅ only add extra X padding jab scrollable na ho
//   paddingX: tabsData.length > 8 ? 1 : 2.2,
// },
//                   }}
